import React, { Component } from "react";
import { ItemMinicart } from "components/ProductItem";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Spinner } from "components/Spinner";

import { formatPrice } from "utils";

class MinicartContainer extends Component {
  componentDidMount = () => {
    document.addEventListener("mousedown", this.handleClickOutsideMinicart);
  };

  handleClickOutsideMinicart = event => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.props.closeMinicart();
    }
  };

  handleNavigateAwayClick = () => {
    this.props.closeMinicart();
  };

  setWrapperRef = node => {
    this.wrapperRef = node;
  };

  render() {
    const {
      handleCloseClick,
      cartProducts,
      cartPrice,
      cartLoading
    } = this.props;
    return (
      <div
        className={`uiPopup__popup uiPopup__popup--right minicartContainer`}
        ref={this.setWrapperRef}
      >
        <button
          className="uiPopup__closeButton uiPopup__closeButton--left"
          onClick={handleCloseClick}
        >
          <i className="fas fa-times" />
        </button>
        <h2 className="columnWrapper__title">Your Cart:</h2>
        <ul className="cartList">
          {cartProducts.length > 0
            ? cartProducts.map(product => (
                <ItemMinicart key={product.sku} product={product} />
              ))
            : false}
        </ul>

        {cartPrice > 0 && cartProducts.length > 0 ? (
          <div>
            <div className="cartList__total">
              <strong>Cart total: </strong>
              {formatPrice(cartPrice)}
            </div>

            <Link
              onClick={this.handleNavigateAwayClick}
              className="button button--cta"
              to="/cart"
            >
              My Shopping Cart
            </Link>
          </div>
        ) : (
          <p>There are no products in the cart.</p>
        )}
        {cartLoading ? <Spinner /> : null}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { cartProducts, cartPrice } = state.cartReducer;
  const { cartLoading } = state.animationsReducer;

  return {
    cartProducts: cartProducts,
    cartPrice: cartPrice,
    cartLoading: cartLoading
  };
};

export default connect(mapStateToProps)(MinicartContainer);



// WEBPACK FOOTER //
// ./src/components/Minicart/components/MinicartContainer.jsx